export default "__VITE_ASSET__CngWtiu4__"